import React from 'react';

export interface VideoManagerContextType {
  videoStartedPlaying: (videoId: string) => void;
  videoStoppedPlaying: (videoId: string) => void;
  canAutoplay: () => boolean;
}

export const VideoManagerContext = React.createContext<VideoManagerContextType>(
  {
    videoStartedPlaying: () => undefined,
    videoStoppedPlaying: () => undefined,
    canAutoplay: () => false,
  }
);

type Props = {
  children: React.ReactNode;
};

export function VideoManagerProvider({children}: Props) {
  const [currentlyPlayingVideo, setCurrentlyPlayingVideo] = React.useState<
    Array<string>
  >([]);

  function videoStartedPlaying(videoId: string) {
    setCurrentlyPlayingVideo((current) => [...current, videoId]);
  }

  function videoStoppedPlaying(videoId: string) {
    setCurrentlyPlayingVideo((current) => current.filter((v) => v !== videoId));
  }

  function canAutoplay() {
    return currentlyPlayingVideo.length === 0;
  }

  const value = {videoStartedPlaying, videoStoppedPlaying, canAutoplay};

  return (
    <VideoManagerContext.Provider value={value}>
      {children}
    </VideoManagerContext.Provider>
  );
}
